// Mirror of backend/tier_utils.py — keep in sync.
//
// The backend always clamps forecast horizons to the user's tier ceiling, so
// the frontend asking for a bigger value is harmless (it just gets clamped).
// We still send the right value so paying users get the longer projection
// they're paying for, and to keep the network payload honest.
export const TIER_RANK = { free: 0, pro: 1, pro_plus: 2 };
export const MAX_FORECAST_MONTHS = { free: 6, pro: 18, pro_plus: 36 };
const PRIVILEGED_ROLES = new Set(['admin', 'staff', 'owner']);

export const isOwner = (user) => user?.role === 'owner';
export const isAdminOrAbove = (user) => user?.role === 'admin' || user?.role === 'owner';
export const isStaffOrAbove = (user) => PRIVILEGED_ROLES.has(user?.role);

export const effectiveTier = (user) => {
  if (!user) return 'free';
  if (PRIVILEGED_ROLES.has(user.role)) return 'pro_plus';
  return user.tier || 'free';
};

export const hasTier = (user, minTier) => {
  return (TIER_RANK[effectiveTier(user)] ?? 0) >= (TIER_RANK[minTier] ?? 0);
};

export const maxForecastMonths = (user) =>
  MAX_FORECAST_MONTHS[effectiveTier(user)] ?? MAX_FORECAST_MONTHS.free;

export const TIER_LABEL = { free: 'Ember', pro: 'Steel', pro_plus: 'Damascus' };
